export default __webpack_public_path__ + "static/media/Sorcerer's Boots of Prestige.1110ffd1.jpg";